export default {
  // 2.0.1で追加
  loading: false,
  rootUser: false,
  subUserName: null,
  tagLimit: 10,
  userMeta: {},
  // ここまで

  sideMenuOpen: false,

  vendor: '',
  readyMonth: '',

  //cancel token
  cancelToken: {
    getAccountDaily: '',
    getAccountMonthly: '',
    getDailyGroup: '',
    getMonthlyGroup: '',
    getTagValue: '',
    getTagDaily: '',
    getTagMonthly: '',
    getTagReport: '',
  },

  // user state
  userState: {
    id: '',
    name: '',
    mail: '',
    paymentId: '',
    paymentType: '',
    meta: {},
    logo: null,
    plan: {
      expire: null,
      start: '',
      type: 'registered',
    },
    startTime: '',
    companyName: '',
    companyId: '',
    settings: {
      language: 'ja', //ログインページではCookieから取得
    },
    dataType: '',
    dataStyle: '',
    dataReady: {
      report: '',
      invoice: '',
    },
    tag: '',
    userMeta: {},
    userId: '',
    accessGroup: '',
    billingGroupId: '',
    billingGroups: [],

    // announcement: false, //Cookieから取得
    // notification: {
    //   email: '',
    //   slack: '',
    // },
    // rateInfo: {
    //   data: [],
    // },
    // accountListType: 'account',
  },

  // account page
  // account: {
  //   selectedId: '',
  //   selectedName: '',
  //   list: {
  //     data: [],
  //     loading: false,
  //     loadErr: null,
  //   },
  // },

  // group page
  // accountGroup: {
  //   selectedId: '',
  //   selectedName: '',
  //   selectedMonth: '',
  //   list: {
  //     data: [],
  //     loading: false,
  //     loadErr: null,
  //   },
  //   data: {
  //     describe: {
  //       data: {
  //         accounts: [],
  //         company_id: '',
  //         group_id: '',
  //         group_name: '',
  //       },
  //       loading: false,
  //       loadErr: null,
  //     },
  //     daily: {
  //       data: [],
  //       loading: false,
  //       loadErr: null,
  //     },
  //     monthly: {
  //       data: [],
  //       loading: false,
  //       loadErr: null,
  //     },
  //   },
  //   loading: false,
  //   loadErr: null,
  // },

  // tag page
  // accountTag: {
  //   selectedName: '',
  //   list: {
  //     data: '',
  //     active: [],
  //     inactive: [],
  //     loading: false,
  //     loadErr: null,
  //   },
  //   tagValue: {
  //     list: [],
  //     data: [],
  //     loading: false,
  //     loadErr: null,
  //     selectedValue: '',
  //     daily: {
  //       data: [],
  //       loading: false,
  //       loadErr: null,
  //     },
  //     monthly: {
  //       data: [],
  //       loading: false,
  //       loadErr: null,
  //     },
  //   },
  //   activeTags: {
  //     data: '',
  //     loading: false,
  //     loadErr: null,
  //   },
  //   inActiveTags: {
  //     data: '',
  //   },
  //   tagLimit: 10,
  //   data: {
  //     describe: '',
  //     daily: '',
  //     monthly: '',
  //   },
  //   loading: false,
  //   loadErr: null,
  // },
  invoice: {
    selectedMonth: '',
  },
  // invoice
  // invoice: {
  //   selectedMonth: '',
  //   // invoiceFormat: '001',
  //   report: {
  //     version: '',
  //     data_02: {
  //       _TOTAL: {},
  //       report: [],
  //       version: '',
  //       aggregation: '',
  //       company_id: '',
  //     },
  //     data: {
  //       report: {
  //         _COMPANY_TOTAL: '',
  //         _COMPANY_TOTAL_DISCOUNTED: '',
  //         _COMPANY_TOTAL_DISCOUNT_RATE: '',
  //         _COMPANY_TOTAL_EXCHANGE_RATE: '',
  //         _COMPANY_TOTAL_JPY: '',
  //         company_id: '',
  //       },
  //     },
  //     loading: false,
  //     loadErr: null,
  //   },
  //   url: {
  //     data: '',
  //     loading: false,
  //     loadErr: null,
  //   },
  //   loading: false,
  //   loadErr: null,
  //   paymentType: '',
  //   version: '0.2',
  // },
  // RI
  // ri: {
  //   list: [],
  //   data: {
  //     covered: '',
  //     uncovered: '',
  //   },
  //   report: {
  //     url: '',
  //     loading: false,
  //     loadErr: null,
  //   },
  //   loading: false,
  //   loadErr: null,
  // },

  windowWidth: window.innerWidth,
};
